import { useDispatch, useSelector } from "react-redux";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import AccountTab from "../../components/account/AccountTab";
import { GroupsTab } from "../../components/account/tabs/GroupsTab";
import AccountSidebar from "../../components/account/AccountSidebar";
import { Fragment, useRef, useState, useEffect, useCallback } from "react";
import AccountTabModal from "../../components/account/AccountTabModal";
import AccountProfileSection from "../../components/account/AccountProfileSection";
import { getGroupByUserId, resetLoadingMore } from "../../redux/ApiSlice/Group/GroupSlice";

export default function Group() {
    const dispatch = useDispatch();
    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const groupData = useSelector((state) => state.group);
    const { User_profile } = ProfileDetails;
    const { data: groupList, loading, loadingMore, nextPage } = groupData;

    console.log("Group List:", groupList);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [show, setShow] = useState(false);
    const [activeTab, setActiveTab] = useState("");
    const ref = useRef(null);
    const groupScrollRef = useRef(null);

    const handleClickOutside = () => {
        setShow(false);
        setActiveTab("");
    };
    useOutsideClick(ref, handleClickOutside);

    const openDrawer = () => setIsDrawerOpen(true);
    const closeDrawer = () => setIsDrawerOpen(false);

    const fetchData = useCallback(async () => {
        if (User_profile?.id) {
            try {
                await dispatch(getGroupByUserId({ userId: User_profile.id }));
            } catch (error) {
                console.error(error);
            }
        }
    }, [dispatch, User_profile?.id]);

    const handleGroupScroll = useCallback(() => {
        const container = groupScrollRef.current;
        if (!container || !nextPage || loadingMore) {
            return;
        }

        const hasReachedBottom =
            container.scrollTop + container.clientHeight >= container.scrollHeight - 10;

        if (hasReachedBottom) {
            dispatch(
                getGroupByUserId({
                    userId: User_profile?.id,
                    nextUrl: nextPage,
                    isLoadMore: true,
                })
            );
        }
    }, [dispatch, loadingMore, nextPage, User_profile?.id]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        dispatch(resetLoadingMore());
        fetchData();
    }, [fetchData, dispatch]);

    useEffect(() => {
        const container = groupScrollRef.current;
        if (!container) return;

        container.addEventListener("scroll", handleGroupScroll);

        return () => {
            container.removeEventListener("scroll", handleGroupScroll);
        };
    }, [handleGroupScroll]);

    return (
        <Fragment>
            <div
                ref={groupScrollRef}
                className={`bg-[#fff] dark:bg-[#1E1D21] overflow-hidden h-full relative ${isDrawerOpen ? "" : 'overflow-y-scroll'}`}
            >
                <div className="">
                    <AccountProfileSection
                        handleOpenSideBar={openDrawer}
                        handleCloseSideBar={closeDrawer}
                        isDrawerOpen={isDrawerOpen}
                        setActiveTab={setActiveTab}
                        setShow={setShow}
                        show={show}
                    />
                </div>

                <div className="sticky top-0 z-30">
                    <AccountTab activeTab={"Groups"} />
                </div>

                <div className="pb-2 h-full w-full">
                    <GroupsTab
                        userId={User_profile?.id}
                        groupList={groupList}
                        loading={loading}
                    />
                    {loadingMore && (
                        <div className="flex justify-center items-center py-4 px-2">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-white"></div>
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-12 overflow-hidden">
                    <div className="col-span-12">
                        <AccountSidebar
                            isDrawerOpen={isDrawerOpen}
                            setIsDrawerOpen={setIsDrawerOpen}
                            openDrawer={openDrawer}
                            closeDrawer={closeDrawer}
                        />
                    </div>
                </div>

            </div>

            {show && (
                <div className={"absolute h-full w-full top-0 overflow-hidden"}>
                    <div
                        className="absolute h-screen w-full top-0 opacity-100 bg-opacity-70 bg-black z-50"
                        onClick={handleClickOutside}
                    />
                    <div
                        ref={ref}
                        className="absolute top-0 left-4 z-50 w-[90%] h-[-webkit-fill-available] mt-4 mb-3 flex justify-center rounded-lg  bg-black duration-1000 transform opacity-100"
                    >
                        <AccountTabModal
                            ref={ref}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                    </div>
                </div>
            )}
        </Fragment>
    )
}
